export const PageLoading = () => (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-2">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-pink-600 border-t-transparent"></div>
            <p className="text-slate-500 font-medium animate-pulse">Carregando...</p>
        </div>
    </div>
)
